import request from '@/utils/request'

// 查询爱心企业管理列表
export function listFirm(query) {
  return request({
    url: '/h5/firm/list',
    method: 'get',
    params: query
  })
}

// 查询爱心企业管理详细
export function getFirm(id) {
  return request({
    url: '/h5/firm/' + id,
    method: 'get'
  })
}
